import { Button } from "primereact/button";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setSidebar } from "../../../../app/appSlice";
import { IDomaine } from "../../cdsApiSlice";
import DeleteDomaine from "./DeleteDomaine";
import DomainDetail from "./DomainDetail";
import ImpossibleDomaineRemove from "./DomainNotDeletable";
import UpdateDomain from "./UpdateDomaine";
import { useSecureApplication } from "../../../../hooks/KeycloackConnection";
import { useZonesQuery } from "../../cdsApiSlice";


interface IDomaineActions {
    domaine:IDomaine
}



const ActionsDomain = ({domaine}:IDomaineActions) => {

  const dispatch = useDispatch()
  const [dialogUpdate,setDialogUpdate] = useState<boolean>(false)
  const [dialogImpossibleDelete,setDialogImpossibleDelete] = useState<boolean>(false)
  const [dialogDeleteDomain,setDialogDeleteDomain] = useState<boolean>(false)
  const { hasAnyPerm} = useSecureApplication();
  const { data: zones, ...zoneStatus } = useZonesQuery()

  return (
    <>
      <UpdateDomain domaine={domaine} errorDialog={dialogUpdate} setter={() => setDialogUpdate(false)} udpate={() => {}} />
      <ImpossibleDomaineRemove domaine={domaine} displayComponent={dialogImpossibleDelete} setter={() => setDialogImpossibleDelete(false)} />
      <DeleteDomaine closeDialog={() => setDialogDeleteDomain(false)} domaine={domaine} visibleDialog={dialogDeleteDomain}/>
      <div className="flex flex-wrap">
          <div> 
            <Button className="p-button-text" icon="pi pi-info-circle" onClick={() => {
              dispatch(
                setSidebar({
                  title: "Détails du domaine",
                  content: (
                    <DomainDetail
                      domaine={domaine}
                    />
                  ),
                })
              )
            }}/>
          </div>

          { hasAnyPerm("gds.manage") &&
            <>
              <div>
                <Button className="p-button-text" icon="pi pi-pencil" onClick={() => setDialogUpdate(true)}  />
              </div> 
              <div> 
                <Button className="p-button-text" icon="pi pi-trash" onClick={() => {
                  domaine.sourcesCount > 0 ? setDialogImpossibleDelete(true): setDialogDeleteDomain(true) 
                }}/>
              </div>
            </>
          }
      </div>
    </>
  )
}

export default ActionsDomain;
